var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-info global-info--dealer" }, [
    _vm.index
      ? _c("span", { staticClass: "index" }, [_vm._v(_vm._s(_vm.index))])
      : _vm._e(),
    _vm._v(" "),
    _vm.dealerMerged
      ? _c(
          "address",
          { staticClass: "address" },
          [
            _c("span", [_c("strong", [_vm._v(_vm._s(_vm.dealerMerged.name))])]),
            _vm._v(" "),
            _vm._l(_vm.enabledTypeFilters, function (filter) {
              return _vm.enabledTypeFilters
                ? [
                    _vm.dealerMerged.dealerTypes.includes(filter.name)
                      ? _c("span", { staticClass: "typo-light" }, [
                          _vm._v(_vm._s(filter.label)),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e()
            }),
            _vm._v(" "),
            _c("span", { staticClass: "spacer" }, [
              _c("span", [_vm._v(_vm._s(_vm.dealerMerged.address))]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.dealerMerged.zip) +
                    " " +
                    _vm._s(_vm.dealerMerged.city)
                ),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.countryName(_vm.dealerMerged.country))),
              ]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "spacer" }, [
              _vm.dealerMerged.phone
                ? _c("p", { staticClass: "contact__phone" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("global-info-dealer.phone")) +
                        "\n                "
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.dealerMerged.phone))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.dealerMerged.phone
                ? _c("p", { staticClass: "contact__fax" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("global-info-dealer.fax")) +
                        "\n                "
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.dealerMerged.fax))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.dealerMerged.email !== ""
                ? _c("p", { staticClass: "contact__email" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("global-info-dealer.email")) +
                        "\n                "
                    ),
                    _c(
                      "a",
                      { attrs: { href: "mailto:" + _vm.dealerMerged.email } },
                      [_vm._v(_vm._s(_vm.dealerMerged.email))]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.dealerMerged.email !== ""
                ? _c("p", { staticClass: "contact__web" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("global-info-dealer.web")) +
                        "\n                "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.validateLinkAddress(_vm.dealerMerged.web),
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(_vm.dealerMerged.web))]
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.enableDealerSelection
              ? _c(
                  "global-button",
                  {
                    attrs: { theme: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("choose", _vm.dealerMerged)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("global-info-dealer.button.chooseDealer"))
                    ),
                  ]
                )
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }